import React from "react";
import { MdArrowForwardIos } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const Card = ({ item }) => {
  const Navigate = useNavigate();
  
  return (
    <div
      className="px-4 pt-4 pb-2 flex flex-col w-full bg-white cursor-pointer shadow-xl shadow-Background2 transform transition duration-300 hover:scale-105 
             rounded-t-9xl rounded-b-4xl justify-center" onClick={()=>{
              Navigate(`/product/${item?._id}/${item?.type}`)
            }}
    >
      <div className="flex flex-col justify-center items-center   w-full">
        <div className="w-48 h-48 md:w-20 md:h-20 lg:w-24 lg:h-24 xl:w-28 xl:h-28 2xl:w-48 2xl:h-48 rounded-full">
          <img
            src={item?.image?.location}
            className="w-full h-full object-cover py-2 md:py-1 rounded-full"
            alt=""
          />
        </div>
        <span className="text-textColor text-xl w-52 flex flex-wrap justify-center mt-8 md:mt-0 ">{item?.name}</span>
      </div>
     
        <div className="flex gap-2 items-center  justify-center py-3 rounded-b-xl font-semibold text-textColor hover:text-Background6 mt-10 sm:10 md:mt-5 xl:mt-3">
          <span>Explore</span>
          <MdArrowForwardIos />
        </div>
     

     
    </div>
  );
};

export default Card;
